


import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import Workspace from "./Workspace";
import { useAuth } from "../../context/auth";
import { useWebSocket } from "../../context/UseWebSocketContext";

const Home = () => {
  const { wsData } = useWebSocket();
  const { getLoginToken, getGoogleAuthToken, storeSecKey } = useAuth();
  const profile = wsData || {};
  
  const token = getLoginToken() || getGoogleAuthToken();
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // ✅ Check authentication
  useEffect(() => {
    const hasToken = token && token !== "" && token !== "undefined" && token !== "null" && token.length > 10;
    console.log("🏠 Home - Token check:", { hasToken, tokenLength: token?.length });
    
    if (hasToken) {
      setIsAuthenticated(true);
    } else {
      setIsAuthenticated(false);
    }
    setIsLoading(false);
  }, [token]);

  // ✅ Store security key when available
  useEffect(() => {
    if (profile?.sec_key && profile.sec_key !== "undefined" && profile.sec_key !== "null" && profile.sec_key.length > 10) {
      storeSecKey(profile.sec_key);
      console.log("✅ Security key stored from Home:", profile.sec_key.substring(0, 15) + "...");
    }
  }, [profile?.sec_key, storeSecKey]);

  // ✅ Show loading
  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-gray-900 z-50">
        <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // ✅ Redirect if not authenticated
  if (!isAuthenticated) {
    console.log("🚪 Home - Not authenticated, redirecting to login");
    return <Navigate to="/login" replace />;
  }

  return (
    <div className="h-screen w-full">
      <Workspace
        darkMode={false}
        showAddPanel={true}
      />
    </div>
  );
};

export default Home;